/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library ikmports
import { Component } from 'react';
import { Button, Modal } from 'react-bootstrap';
import axios from 'axios';
import './ChangeBidder.scss';
import {  getBuyerHeaders, getBuyerUrl } from 'shared/http';

import { change_bidder, bidders_list } from "shared/settings/apiconfig";
import toast from 'shared/toast';
/**
 * this page is used to view or add notes for sale or item
 * 
 * @param props
 * 
 * @returns html code to render note modal box
 * 
**/

export default class ChangeBidder extends Component {
    constructor(props) {
        super(props);
        this.state = {
            bidders: [],
            show:false,
            row:"",
            selectedRow:""
        }
    }

    componentDidMount() {
        this.getbidders()
    }

getbidders(){
    axios.get(getBuyerUrl(`${bidders_list}${this.props.itemsId}`), getBuyerHeaders(this.props.token)).then(
        response => {
            if (response.data.status === 'success') {
                var bidder =response.data.data.filter(item=>item.bidwonstatus === "Won")
                this.setState({
                    show:true,
                    bidders:response.data.data
                },()=>{
                    if(bidder.length>0){
                        this.setState({
                            row: bidder[0],
                            selectedRow: bidder[0],
                        })
                    }
                })
            } else {
                this.props.closeModal()
            }

        }
    ).catch(
        error => {
            this.props.closeModal()
            this.setState({
                ...this.state,
                // show:true,
            })
        }
    );
}
onChangeBidder(index,row){
    var bidders =this.state.bidders
    var bidder =bidders.filter(item=>item.bidwonstatus === "Won")
    if(bidder.length>0){
        var bidderIndex = bidders.indexOf(bidder[0])
        bidders[bidderIndex]["bidwonstatus"]=""
    }
    bidders[index]["bidwonstatus"]="Won"
    this.setState({
        index,
        row,
        bidders
    })
}

submit(){
    const { row } = this.state
    var data = {
        "data": {
            "itemid":  this.props.itemsId,
            "buyerid": row.buyerid
        }
    }
    axios.put(getBuyerUrl(`${change_bidder}`),data, getBuyerHeaders(this.props.token)).then(
        response => {
            if (response.data.status === 'success') {
                toast.success("Successfully Updated")
                this.props.closeModal()
            }
        }
    ).catch(
        error => {
            toast.error(error.response.data['message']);
            this.setState({
                ...this.state,
            })
        }
    );
}
    nth(n){
        return["st","nd","rd"][((n+90)%100-10)%10-1]||"th"
    }
    render() {
        if(this.state.show)
        return (

            <Modal size="lg" centered show={this.props.show} id="change-bidder">
                <div className="bidder-head">
                <h5 className="header text-secondary">Change Bidder</h5>
                <Button  className="header bidder-close" onClick={()=>{ 
                    this.props.closeModal()
                    }} variant="">X</Button>
                </div>
                <Modal.Body>
                    <div className="change-bidder-content">
                        <div>
                            <div className="table-head">
                                <div className="bidder-head">Top Bidders</div>
                                <div className="amount-head">Amount</div>
                            </div>
                            <form name ="radiogrop" className="table-boady">
                                {
                                    this.state.bidders.map((row, index) => (
                                        <div id={`table-row${index}`} className="table-row">
                                            <div className="bidderView" >
                                                <Button disabled={row.bidwonstatus === "Void"} style={{backgroundColor:"white"}} onClick={()=>{this.onChangeBidder(index,row)}} className="radio-button-outer">
                                                    {row.bidwonstatus === "Won" &&<div className="radio-button-inner"></div>}
                                                </Button>
                                                <div className="bidder-text">{row.nickname}</div>
                                            </div>
                                            <div className="amountView">
                                                <div className="amount-text">{`$ ${row.bidprice}`}</div>
                                                <div className="rank-text">{`${index+1} ${this.nth(index+1)} `}</div>
                                            </div>
                                        </div>
                                    ))
                                }
                            </form>
                            <div 
                            style={{display: "flex",justifyContent:"center"}}>
                            <Button
                                disabled={this.state.selectedRow === this.state.row}
                                style={{padding:"1% 5%",marginTop:15}}
                                onClick={() => {
                                    this.submit()
                                }} variant="secondary">Submit</Button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        );
    else
        return(
            <div></div>
        )
    }
}


